import { ScreenHeader } from "@/components/ui/ScreenHeader";
import { vendorStageLabels } from "@/constants";
import { ApplicationStageId } from "@/lib/api/vendor";
import { Stack, useLocalSearchParams, useSegments } from "expo-router";

export default function ApplicationLayout() {
  const segments = useSegments();
  const { stage } = useLocalSearchParams<{ stage: string }>();
  const stageId = stage as ApplicationStageId;
  const stageLabel = vendorStageLabels[stageId];

  const showTitle = segments[segments.length - 1] === "[stage]";

  return (
    <Stack
      screenOptions={{
        headerShown: true,
        header: (props) => (
          <ScreenHeader title={showTitle ? stageLabel?.title : undefined} {...props} />
        ),
      }}
    />
  );
}
